import { z } from 'zod';
import { surveySectionSchema } from './pollSurvey';
import { jArticleListSchema, jArticleView } from './article';

export const contentFactoryTypes = 'pollSurvey';

export const contentFactoryDefaultDataSchema = z.object({});
export const contentFactorySurveyDataSchema = z.object({
    pollContent: surveySectionSchema.array(),
    pollLinks: z.record(z.string(), z.string()).or(z.null()),
    pollMessage: z.string().optional(),
    description: z.string().optional(),
    anonymousResponse: z.string().or(z.null()).optional(),
    multipleResponse: z.string().or(z.null()).optional(),
    pollResponseAuthorVisibility: z.string().or(z.null()).optional(),
    pollResponseUserVisibility: z.string().or(z.null()).optional(),
    pollResponseShowProgression: z.string().or(z.null()).optional(),
    pollResponseShowRespondent: z.string().or(z.null()).optional(),
    bannerSrc: z.string().optional(),
});

export type ContentFactorySurveyData = z.infer<typeof contentFactorySurveyDataSchema>;

export const combinedContentFactoryDataSchema = z.union([
    contentFactoryDefaultDataSchema,
    contentFactorySurveyDataSchema,
]);

export const contentFactoryBaseTemplateSchema = jArticleListSchema.extend({
    contentFactoryTemplateType: z.enum(['pollSurvey']),
    contentFactoryTemplateAuthor: z.string(),
    contentFactoryTemplateUsage: z.number(),
});

export const contentFactorySurveyTemplateSchema = contentFactoryBaseTemplateSchema.extend({
    contentFactoryTemplateType: z.literal('pollSurvey'),
    contentFactoryTemplateData: contentFactorySurveyDataSchema,
});
export const contentFactoryDefaultTemplateSchema = contentFactoryBaseTemplateSchema.extend({
    contentFactoryTemplateType: z.literal('default'),
    contentFactoryTemplateData: contentFactoryDefaultDataSchema,
});

export const combinedContentFactoryTemplateSchema = z.union([
    contentFactoryDefaultTemplateSchema,
    contentFactorySurveyTemplateSchema,
]);

export const contentFactoryTemplateViewSchema = combinedContentFactoryTemplateSchema;

export type jContentFactoryTemplateList = z.infer<typeof contentFactoryBaseTemplateSchema>;
export type jContentFactoryTemplateView = jArticleView & z.infer<typeof contentFactoryTemplateViewSchema>;
